<script setup lang="ts">
defineProps<{
  show: boolean;
  title?: string;
  message?: any;
}>();

const emit = defineEmits(['close']);

const closeModal = () => {
  emit('close');
};
</script>

<template>
  <div class="modal modal-sm active" v-if="show">
    <div class="modal-overlay" @click="closeModal()"></div>
    <div class="modal-container">
      <div class="modal-header">
        <div class="modal-title h5">
          {{ title }}
        </div>
      </div>
      <div class="modal-body">
        <span class="texto">
          {{ message }}
        </span>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" @click="closeModal()">OK</button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modal {
  .modal-header {
    padding: 0.8rem 0.4rem 0.4rem;
  }
  .modal-body {
    padding: 0.4rem;
  }
}
</style>
